
function addToCart(itemId, quantity) {
  $.post('/cart/add.js', {
    quantity: quantity ? quantity : 1,
    id: itemId
  }).always(
    function() {
      window.location.href="/cart";
    }
  ); 
}
  
  
  $('div.styles a').on('click', function() {
    var $gender = $(this).data('gender');
    var $id = $(this).data('id');
    $('div.banner-container').hide();
    $('div.prod-container').hide();
    $('div.' + $gender + '-banner-' + $id).show();
    $('div.' + $gender + '-prods-' + $id).show();
    $('div.giftcard-container').show();
	setTimeout(function(){ generateBestSellers($gender, $id); }, 1000);

    
  });

  // Select all links with hashes to scroll to
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .on('click', function(event) {
      var activator = $(this).data('activator') || $(this).attr('href');
      // show/hide elements first, prior to animating to it:
      if (activator === "#his-heading" || activator === "#her-heading") {
        $('.heading, .styles').hide();
        $('div.banner-container').hide();
        $('div.prod-container').hide();
        $('div.topsellers').hide();
        $('div.giftcard-container').hide();

        var clas = '.'+$(this).parent().data('gender');
        $(clas + '-heading').show();
        $(clas + '-style').show();
      }

      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top-131
          }, 500, function() {
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    }
  );

  // TOP SELLERS:
  
  
  var generateBestSellers = function (gender, id) {
    if (collections[gender][id]) {
      $('div.topsellers').show();

      if($('#topSellersCarousel').hasClass('slick-initialized')) {
        $('#topSellersCarousel').slick('removeSlide', null, null, true);
        addSlides(gender, id);
      } else {
        $('#topSellersCarousel').slick({
          dots: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
          prevArrow: $('.topsellers-control--prev'),
          nextArrow: $('.topsellers-control--next'),
          responsive: [
            {
              breakpoint: 769, //at 768 wide, only 2 slides will show
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                centerMode: true
              }
            },
            {
              breakpoint: 481, //at 480px wide, only one slide will show
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                centerMode: true,
                dots: true
              }
            }
          ]
        });
        addSlides(gender, id);
      }
    }
  }
  
  var executed = false;
  
  var addSlides = function (gender, id) {
    collections[gender][id].slice(3).forEach(function(v, i) {
      var shown = false;
      var carouselItem = '<div class="triggerModal" data-href="/products/' + v.handle + '" onclick="$(\'#carouselGiftGuideModal_' + v.handle + '\').fadeIn();">';
//       carouselItem += '<a href="/products/' + v.handle + '">';
      carouselItem += '<img class="" src=' + v.featured_image + ' alt=' + v.title + '>';
      carouselItem += '<div class="prod-caption">';
      carouselItem += '<p class="prod-title">' + v.title + '</p>';
//       carouselItem += '<p class="prod-price">$' + (v.price/100).toFixed(2) + '</p></div></div>';
      
      var carouselModal = '<div class="carouselGiftGuide giftGuideModalHolder" id="carouselGiftGuideModal_' + v.handle + '">';
      carouselModal += '<div class="giftGuideModalContent">';
      carouselModal += '<span class="giftGuideModalClose" onclick="$(\'#carouselGiftGuideModal_' + v.handle + '\').fadeOut();">X</span>';
      carouselModal += '<h2>' + v.title + '</h2><hr>';
      carouselModal += '<div class="giftGuideModalLeft">';
      carouselModal += '<div class="giftGuideModalImage">';
      carouselModal += '<img src="' + v.images[0] + '"/></div></div>';
      carouselModal += '<div class="giftGuideModalRight">';
      if(v.description.length > 0) {
      	carouselModal += '<div class="giftGuideModalDescription"><h2>View Description</h2><div class="hiddenDescription">' + v.description + '</div></div>';
      }
      carouselModal += '<div class="product-variants">';
      carouselModal += '<select id="modal_product-select_' + v.handle + '" name="id" class="giftGuideModalSelect boxify">';
      for (var i = 0; i < v.variants.length; i++ ) {
        if(v.variants[i].available){
          shown = true;
          carouselModal += '<option value="'+ v.variants[i].id +'">' + v.variants[i].title +' - $'+ (v.variants[i].price/100).toFixed(2) +'</option>';
        }
      }
      carouselModal += '</select></div><div class="product-price-box"></div>';
      carouselModal += '<button class="giftGuideModalAdd" onclick="addToCart($(\'#modal_product-select_' + v.handle + '\').val())">Add to Cart</button>';
      carouselModal += '<button class="giftGuideModalCancel" onclick="$(\'#carouselGiftGuideModal_' + v.handle + '\').fadeOut();">Cancel</button>';
      carouselModal += '</div></div></div>'
      if(shown) {
        $(".gift-guide").append(carouselModal);

        $('#topSellersCarousel').slick('slickAdd', carouselItem);
        
        $('#carouselGiftGuideModal_' + v.handle).find(".selector-wrapper").remove();
        new Shopify.OptionSelectors('modal_product-select_' + v.handle, { product: v, onVariantSelected: selectCallback, enableHistoryState: false });
      }
    });
    
    if(!executed) {
      executed=true;
      for(var i = 0; i < callbackSelects.length; i++){
        if(callbackSelects[i]){        
          new Shopify.OptionSelectors('modal_product-select_' + callbackSelects[i].handle, { product: callbackSelects[i], onVariantSelected: selectCallback, enableHistoryState: false });
          new Shopify.OptionSelectors('product-select_' + callbackSelects[i].handle, { product: callbackSelects[i], onVariantSelected: selectCallback, enableHistoryState: false });
        }
      }
    	$(".prod-container .selector-wrapper select").boxify();

      $(".prod-container .giftGuideModalDescription").on('click', function(){
        $(this).find(".hiddenDescription").slideToggle();
        var h2Block = $(this).find("h2")[0]
        if(h2Block.textContent == "View Description"){
          h2Block.textContent = "Hide Description";
        } else {
          h2Block.textContent = "View Description";
        }
      });
    }
    
    
    $(".carouselGiftGuide .boxify-selector").remove();
    $(".carouselGiftGuide .selector-wrapper select").boxify();
    
    
      $(".selector-wrapper label").filter(function() {
        return $(this).text() === "Bulk Discount";
      }).parent().hide();
      $(".boxify-selector").filter(function() {
        return $(this).text() === "Default Title" || $(this).text() === "1" || $(this).text().indexOf("/$") > 0;
      }).hide();
    
    
    $(".carouselGiftGuide .giftGuideModalDescription").on('click', function(){
      $(this).find(".hiddenDescription").slideToggle();
      var h2Block = $(this).find("h2")[0]
      if(h2Block.textContent == "View Description"){
        h2Block.textContent = "Hide Description";
      } else {
        h2Block.textContent = "View Description";
      }
    });
    
  }